module.exports = __webpack_public_path__ + "static/media/gel.33c8a847.png";